import { createApp } from 'vue';
import ProgressCircle from './components/ProgressCircle.vue';
import CountdownTimer from './components/CountdownTimer.vue';
// import TeaserQuestions from './components/TeaserQuestions.vue';
import DeckOfCards from './components/DeckOfCards.vue';

const app = createApp({});

app.component('progress-circle', ProgressCircle);
app.component('countdown-timer', CountdownTimer);
// app.component('teaser-questions', TeaserQuestions);
app.component('deck-of-cards', DeckOfCards);

app.mount('#app');

try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');
  require('bootstrap');
} catch (e) { console.log(e); }

Popper.Defaults.modifiers.computeStyle.enabled = false;
